import React from 'react';
import Modal from '../../../_ui/Modal/Modal';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import Button from '../../../_ui/Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import DoneIcon from '@material-ui/icons/Done';
import { Color } from '../../../components/ThemeProvider/ThemeStyle';
import { setVoucher, vouchersModule } from '../VouchersDucks';
import Form from '../../../_ui/Form/Form';
import * as Yup from 'yup';
import i18next from 'i18next';
import TreeSelect from '../../../_ui/TreeSelect/TreeSelect';
import useTree from '../../../components/TableFilter/ColumnsFilters/FilterTreeSelect/useTree';
import Input from '../../../_ui/Input/Input';

const ValidationSchema = Yup.object().shape({
  queuedRegion: Yup.string().required(() => i18next.t('vouchers_requiredField')),
  voucherNumber: Yup.string().required(() => i18next.t('vouchers_requiredField')),
});

export default function ModalAdd({close}) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const loadingSave = useSelector(state => state[vouchersModule].loadingSave);
  const lookupId = 60;
  const { tree, onExpand, loadingArr } = useTree({
    lookupId: lookupId,
    filter: (item) => item.ARM_gu === 'true'
  });
  return (
    <Modal
      title={t('vouchers_add') }
      open
      onClose={close}
    >
      <Form
        initialValues={{
          queuedRegion: '',
          voucherNumber: '',
        }}
        onSubmit={values => dispatch(setVoucher({ values, close }))}
        validate={ValidationSchema}
      >
      <DialogContent>
        <TreeSelect
          name="queuedRegion"
          fullWidth
          lookupId={lookupId}
          loadingArr={loadingArr}
          onExpand={onExpand}
          data={tree}
        />
        <Input
          name="voucherNumber"
          type={'number'}
          placeholder={t('vouchers_quantity')}
          className="fullwidth"
        />
        <div className="flex justify-end pb2 pt2">
          <Button
            color="primary"
            style={{ backgroundColor: Color.bgColorSuccess }}
            icon={<DoneIcon fontSize="small" className="mr1" />}
            text={ t('vouchers_saveBtn') }
            disabled={loadingSave}
            type="submit"
          />
        </div>
      </DialogContent>
      </Form>
    </Modal>
  );
}
